export default {
    namespaced: true,
    state: {
        user: {},
        isLoggedIn: false
    },
    getters: {
        user: state => state.user,
        kits: state => state.user.kits,
        builds: state => state.user.builds
    },
    mutations: {
        setUser: (state, user) => {
            state.user = user;
        },
        addToKits: (state, kit_id) => {
            state.user.kits.push(kit_id);
        },
        addToBuilds: (state, build) => {
            state.user.builds.push(build);
        },
        removeBuild: (state, build_id) => {
            for (let i = 0; i < state.user.builds.length; i++) {
                let build = state.user.builds[i];
                if (build.id === build_id) {
                    state.user.builds.splice(i,1);
                    break;
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/user.js